"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaPostcode$ = exports.AreaPostcode$outboundSchema = exports.AreaPostcode$inboundSchema = void 0;
exports.areaPostcodeToJSON = areaPostcodeToJSON;
exports.areaPostcodeFromJSON = areaPostcodeFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
/** @internal */
exports.AreaPostcode$inboundSchema = z.object({
    incode: z.nullable(z.string()),
    location: geopointlocation_js_1.GeoPointLocation$inboundSchema,
    outcode: z.string(),
    postcode: z.nullable(z.string()),
});
/** @internal */
exports.AreaPostcode$outboundSchema = z.object({
    incode: z.nullable(z.string()),
    location: geopointlocation_js_1.GeoPointLocation$outboundSchema,
    outcode: z.string(),
    postcode: z.nullable(z.string()),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaPostcode$;
(function (AreaPostcode$) {
    /** @deprecated use `AreaPostcode$inboundSchema` instead. */
    AreaPostcode$.inboundSchema = exports.AreaPostcode$inboundSchema;
    /** @deprecated use `AreaPostcode$outboundSchema` instead. */
    AreaPostcode$.outboundSchema = exports.AreaPostcode$outboundSchema;
})(AreaPostcode$ || (exports.AreaPostcode$ = AreaPostcode$ = {}));
function areaPostcodeToJSON(areaPostcode) {
    return JSON.stringify(exports.AreaPostcode$outboundSchema.parse(areaPostcode));
}
function areaPostcodeFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaPostcode$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaPostcode' from JSON`);
}
//# sourceMappingURL=areapostcode.js.map